module.exports = __webpack_public_path__ + "static/media/background.91d95951.png";